import { Injectable } from "@angular/core";
import { map, catchError, retry } from "rxjs/operators";
import { AppConfig } from "../../configs/app.config";
import { BaseEntityService } from "./rest-common.service";
import { Observable, throwError, of } from "rxjs";
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: 'root'
})
export class RoleService  extends BaseEntityService{
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  // public resource_url = `https://api.jsonbin.io/b/5eca9addbbaf1f2589463bbf`;

  // getRoles() :Observable<any>{
  //     return this.http.get(this.resource_url).pipe(
  //       map((response: HttpResponse<any>) => response)
  //       // ,catchError((err) => this.handleError(err))
  //     )
  // }
}
